export const playerEvents = {
  'CHANGE_MONITOR_MODE': 'changeMonitorMode',
  'SHOW_MONITOR': 'show_monitor',
  'INIT': 'init',
  'GET_CAMERAS_DATA': 'cameras_data',
  'START_EXPORT': 'arch_cnv_export',
  'STOP_EXPORT': 'arch_cnv_cancel',
  'ALERTS': 'alerts',
  'ON_MAP': 'onmap',
  "SET_PLAYER_MODE": 'setPlayerMode',
  'CLOSE_CAMERA': 'closeCamera',
  "ADD_CAMERA": 'camera_drop',
  'LONG_POOL_UPLOAD': 'arch_cnv_poll',
  'PLAYER_DOUBLE_CLICK': 'camera_dbl_click',
  'EXPORT_CONTROL': 'arch_cnv_export_show_control',
}


// WEBPACK FOOTER //
// ./src/components/player/const/playerEvents.js